module.exports = __webpack_public_path__ + "static/media/n8n.5c788b8d.png";